import React from 'react'; // eslint-disable-line no-unused-vars
import ReactDOM from 'react-dom/client';
import { Main, type CarouselSlide } from './main';

if (process.env.NODE_ENV === 'development') {
  console.log('CBF-VIEW-CUSTOM-CAROUSEL: Loading');
}
let loadApp = function () {
  if (process.env.NODE_ENV === 'development') {
    console.log('CBF-VIEW-CUSTOM-CAROUSEL: Initializing React component');
  }
  const elements = document.getElementsByClassName('cbfcustomcarousel');
  for (let i = 0; i < elements.length; i++) {
    const element = elements[i];
    const scriptTag = element.querySelector('script[type="application/json"]');
    const rawSlides = scriptTag ? scriptTag.textContent : element.getAttribute('data-slides');
    let slides: CarouselSlide[] = [];
    if (rawSlides) {
      try {
        const parsed = JSON.parse(rawSlides);
        if (Array.isArray(parsed)) {
          slides = parsed;
        }
      } catch (error) {
        if (process.env.NODE_ENV === 'development') {
          console.log('CBF-VIEW-CUSTOM-CAROUSEL: Failed to parse slides', error);
        }
      }
    }

    let variant = element.getAttribute('data-variant');
    let itemsPerView = element.getAttribute('data-itemsperview');
    let minCardWidth = element.getAttribute('data-mincardwidth');
    let imageHeight = element.getAttribute('data-imageheight');
    let autoplay = element.getAttribute('data-autoplay');
    let autoplayDelay = element.getAttribute('data-autoplaydelay');
    let openInNewTab = element.getAttribute('data-openinnewtab');
    let background = element.getAttribute('data-background');
    let cardBackground = element.getAttribute('data-cardbackground');
    let cardTextColor = element.getAttribute('data-cardtextcolor');
    let titleColor = element.getAttribute('data-titlecolor');
    let textAlign = element.getAttribute('data-textalign');
    let buttonBackground = element.getAttribute('data-buttonbackground');
    let buttonTextColor = element.getAttribute('data-buttontextcolor');

    while (element.firstChild) {
      element.removeChild(element.firstChild);
    }

    const root = ReactDOM.createRoot(element);
    root.render(
      <Main
        slides={slides}
        variant={variant ?? ''}
        itemsPerView={itemsPerView ?? ''}
        minCardWidth={minCardWidth ?? ''}
        imageHeight={imageHeight ?? ''}
        autoplay={autoplay ?? ''}
        autoplayDelay={autoplayDelay ?? ''}
        openInNewTab={openInNewTab ?? ''}
        background={background ?? ''}
        cardBackground={cardBackground ?? ''}
        cardTextColor={cardTextColor ?? ''}
        titleColor={titleColor ?? ''}
        textAlign={textAlign ?? ''}
        buttonBackground={buttonBackground ?? ''}
        buttonTextColor={buttonTextColor ?? ''}
      />,
    );
  }
};
if (document.readyState === 'loading') {
  if (process.env.NODE_ENV === 'development') {
    console.log('CBF-VIEW-CUSTOM-CAROUSEL: Waiting for document ready state');
  }
  document.addEventListener('DOMContentLoaded', loadApp);
} else {
  loadApp();
}
